import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {injectIntl} from "gatsby-plugin-react-intl";
import ImageFluid from "./image-fluid";

const Story = ({ intl, content }) => (

    <div className={`story`}>
        <Row>
            <Col lg={5}>
                <div className={`image`}>
                    <ImageFluid alt={``} filename={content.image} />
                </div>
            </Col>
            <Col lg={7}>
                <div className={`text-area`}>
                    <div className={`text`} dangerouslySetInnerHTML={{ __html: content.text }}></div>
                </div>
            </Col>
        </Row>
    </div>

)

export default injectIntl(Story)
